import { Eye, BookOpen } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BookCard = ({ book, index, onClick }) => {
  return (
    <div
      data-testid={`book-card-${book.id}`}
      className="book-card book-appear"
      style={{ animationDelay: `${Math.min(index * 40, 600)}ms` }}
      onClick={onClick}
    >
      <div className="relative">
        <img
          src={`${API_URL}/library/books/${book.id}/cover?thumb=1`}
          alt={book.title}
          loading="lazy"
          className="book-cover-img w-full aspect-[2/3] object-cover rounded-xl bg-amber-50"
          onError={(e) => { e.target.style.objectFit = 'contain'; }}
        />
        <div className="book-spine" />
        <span className="absolute top-2 right-2 bg-amber-500 text-white text-xs font-bold px-2 py-0.5 rounded-full shadow">
          {book.age}+
        </span>
      </div>
      <div className="mt-3 px-1">
        <h3 className="library-font font-bold text-sm text-stone-800 leading-snug line-clamp-2">
          {book.title}
        </h3>
        <p className="text-xs text-stone-500 mt-0.5 line-clamp-1">{book.author}</p>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-stone-400">
          <span className="inline-flex items-center gap-1">
            <BookOpen className="h-3 w-3" /> {book.pages} стр.
          </span>
          {book.read_count > 0 && (
            <span className="inline-flex items-center gap-1" title="Прочетена">
              <Eye className="h-3 w-3" /> {book.read_count}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
